<template>
    <div class="list-search" v-cloak>
        <div class="search-nav" id="gSearchNav"> 
            <ul id="cateNav" class="nav" >
                <li :class="{active:!selectCate}" id="cateId0" @click="bindSelectCate(0)"><p class="nav-name">全部</p></li> 
                <li :id="'cateId'+ cateId" :class="{active:selectCate == cateId}" v-for="(cateName, cateId) in categoryList" @click="bindSelectCate(cateId)"> 
                    <p class="nav-name">{{cateName}}</p>
                </li>
            </ul>
        </div>
        <div class="search-arrow J-show-cate">
            <a href="javascript:;" @click="bindShowAllCate()"><span :class="{'arrow-top':true,'arrow-top-down':!showAllCate,'arrow-top-up':showAllCate}"></span></a>
        </div>
        <div class="all-classify J-show-cate" id="gAllClassify" :class={hide:!showAllCate}>
            <ul class="classify">
                <li @click="bindSelectCate(0)" :class="{active:!selectCate}"><a href="javascript:;" class="classify-name">全部</a></li>
                <li :class="{active:selectCate == cateId}" 
                    v-for="(cateName, cateId) in categoryList" 
                    @click="bindSelectCate(cateId)"><a href="javascript:;" class="classify-name" v-html="cateName"></a></li>
            </ul>
        </div>
    </div>
</template>
<script>
    
    /**
     * 分类的一个组建
     * 依赖jquery 和 iscroll.js
     */
    var iScrollInstance;
    export default {
        /**
         * 声明组建需要设置的参数
         * selectCate：当前选择的cateid
         * categoryList: 类列表
         */
        props: ['selectCate', 'categoryList'],
        data: function() {
            return {
                counter: 0,
                swipeWidth: 1200,
                left: 0,
                ListWidht: 0,
                showAllCate: false
            }
        },
        computed: {},

        watch: {
            selectCate: function(newValue, oldValue) {
                this._showSelectCateButton(newValue)
            }
        },
        mounted: function() {
            var self = this 
            $(document).mouseup(function(e) {
                var _con = $('.J-show-cate');
                if (!_con.is(e.target) && _con.has(e.target).length === 0) {
                    self.showAllCate = false 
                }
            })
            //防止横屏
            //绑定屏幕改变大小事件
            $(window).resize(function () {
                self.$nextTick(function () {
                    self._resize()
                })

            });
        },
        updated: function() {
            this._resize();
        },

        methods: {
            /**
             * 屏幕变化
             * @private
             */
            _resize : function(){
                var poswidth = 0;
                $('#cateNav li').each(function() {
                    poswidth = poswidth + $(this).outerWidth()
                })
                $("#cateNav").css("width", poswidth + 1);
                if (!iScrollInstance) {
                    iScrollInstance = new IScroll('#gSearchNav', {
                        scrollX: true,
                        scrollY: false,
                        click: true
                    });
                }else{
                    iScrollInstance.refresh();
                }
            },

            _showSelectCateButton: function(cateId) {
                var _allWidth = $("#cateNav").width(),
                    $selectCate = $("#cateId" + cateId),
                    _showWidth = $("#gSearchNav").width(),
                    _selectCateWidth = $selectCate.width(),
                    _selectCateLeft = $selectCate.position().left,
                    _left = $selectCate.position().left - (_showWidth - _selectCateWidth) / 2;
                if (_left > _allWidth - _showWidth) {
                    _left = _allWidth - _showWidth
                }
                if (_selectCateLeft < (_showWidth - _selectCateWidth) / 2) {
                    _left = 0
                }
                iScrollInstance.scrollTo(-_left, 0, 500, IScroll.utils.ease.quadratic);
            },
            bindSelectCate: function(cateId) {

                this.showAllCate = false
                this.$emit('navselectcate', cateId)
            },
            //点击显示全部事件
            bindShowAllCate: function() {
                this.showAllCate = !this.showAllCate

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/group-cate-select/group-cate-select.vue